<template src="./template.html"/>
<style scoped src="./stylesheet.scss" lang="scss"/>

<script>
    import CategoryCard from "../../components/CategoryCard/CategoryCard";
    import axios from 'axios';

    export default {
        name: "Home",
        components: {
            CategoryCard
        },
        data() {
            return {
                categories: null,
                error: null
            }
        },
        mounted() {
            // Get categories
            axios({
                method: "GET",
                "url": '/category',
                data: {}
            }).then((response) => {
                this.categories = response.data;
            }).catch((error) => {
                if (error.response.data.error === "Errore generico") {
                    this.error = "Ops, c'è stato un errore inaspettato. Se l'errore persiste contatta l'amministratore di sistema."
                } else {
                    this.error = "Ops, c'è stato un errore inaspettato. Se l'errore persiste contatta l'amministratore di sistema."
                }
                this.$bvModal.show('error-modal');
            });
        }
    }
</script>
